"use client";
import * as React from "react";
const SvgSearchRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.73 10.32H11l-.26-.26a6.1 6.1 0 0 0 1.39-5A6.1 6.1 0 0 0 6.87.05 6.1 6.1 0 0 0 .05 6.87a6.1 6.1 0 0 0 5 5.24 6.1 6.1 0 0 0 5.02-1.39l.25.26v.74l4 4a1 1 0 0 0 1.39 0 1 1 0 0 0 0-1.4zm-5.63 0A4.2 4.2 0 0 1 1.88 6.1 4.2 4.2 0 0 1 6.1 1.88a4.2 4.2 0 0 1 4.22 4.22 4.2 4.2 0 0 1-4.22 4.22" }));
export {
  SvgSearchRound as default
};
